/**
 * Web3 Onboard - single initialization for the app.
 * Prevents "Cannot redefine property: ethereum" from multiple inits
 * and conflicts with wallet extensions (MetaMask, Coinbase, etc.).
 */
import { init } from '@web3-onboard/vue'
import injectedModule from '@web3-onboard/injected-wallets'
import coinbaseWalletModule from '@web3-onboard/coinbase'

const coinbaseWalletSdk = coinbaseWalletModule({ darkMode: true })
const injected = injectedModule()

const chain = process.env.NODE_ENV === 'production'
  ? { id: 137, token: 'MATIC', label: 'Polygon', rpcUrl: 'https://polygon-rpc.com' }
  : { id: 80002, token: 'MATIC', label: 'POLYGON AMOY TESTNET', rpcUrl: 'https://rpc-amoy.polygon.technology/' }

let initialized = false

export function initOnboard() {
  if (initialized) return
  try {
    init({
      wallets: [coinbaseWalletSdk, injected],
      connect: { autoConnectLastWallet: true },
      chains: [chain]
    })
    initialized = true
  } catch (err) {
    // Avoid breaking the app if another extension already locked window.ethereum
    console.warn('[onboard] init skipped or failed:', err?.message || err)
  }
}
